import { useCallback, useEffect, useState } from 'react'
import { PageProps } from '..'
import store from '../../../store'
import { useProjectPrivateContext } from '../../context/projectContext'
import ProfitLossMembersView from './view'
import Auth from '../../../lib/commons/auth'
import { intl } from '../../../i18n'
import { projectPrivate } from '../../higher-order-components/projectPrivate'
import { showAlert } from '../../../store/globalAlert'

type Props = PageProps

const ProfitLossMembersNew = (props: Props) => {
  const { project } = useProjectPrivateContext()
  const [initialized, setInitialized] = useState(false)
  const [certificated, setCertificated] = useState(false)

  const checkAuth = useCallback(async () => {
    if (!project) return
    try {
      const result = await Auth.checkAccountingAuth(
        project.uuid,
        props.externalId
      )
      setCertificated(result)
      if (!result) {
        store.dispatch(
          showAlert({
            message: intl.formatMessage({
              id: 'global.warning.unauthorized.function',
            }),
          })
        )
      }
    } finally {
      setInitialized(true)
    }
  }, [project, props.externalId])

  useEffect(() => {
    if (!initialized) {
      checkAuth()
    }
  }, [checkAuth, initialized])

  if (!certificated) return <></>
  return <ProfitLossMembersView {...props} currentProject={project} />
}

export default projectPrivate(ProfitLossMembersNew)
